var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { ModuleAuthor } from "../";

var InboxModuleAuthors = (_temp2 = _class = function (_Component) {
    _inherits(InboxModuleAuthors, _Component);

    function InboxModuleAuthors() {
        var _temp, _this, _ret;

        _classCallCheck(this, InboxModuleAuthors);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderAuthor = function (author, index) {
            var name = author.name,
                status = author.status;


            if (name) {

                var names = name.split(" ");

                name = names[0];

                if (name.length > 12) {
                    name = name.substr(0, 12) + ".";
                }

                if (names.length > 1) {
                    for (var i = 1; i < names.length; i++) {
                        name = name + " " + names[i].substr(0, 1) + ".";
                    }
                }
            }

            return React.createElement(ModuleAuthor, _extends({}, author, { name: name, status: status, key: index }));
        }, _this.getAuthors = function () {
            var messages = _this.props.messages;


            var read = [];
            var readAuthors = [];

            var unread = [];
            var unreadAuthors = [];

            var unique = [];
            var uniqueAuthors = [];

            messages.map(function (message) {
                var author = message.author,
                    status = message.status;
                var name = author.name;


                if (status === "unread" && !unread.includes(name)) {
                    unread.push(name);
                    unreadAuthors.push(_extends({}, author, {
                        status: status
                    }));
                } else if (!read.includes(name)) {
                    read.push(name);
                    readAuthors.push(_extends({}, author, {
                        status: status
                    }));
                }

                if (!unique.includes(name)) {
                    unique.push(name);
                    uniqueAuthors.push(_extends({}, author, {
                        status: status
                    }));
                }
            });

            return {
                unique: uniqueAuthors,
                read: readAuthors,
                unread: unreadAuthors
            };
        }, _this.renderAuthors = function (authors) {

            var firstAuthor = authors[0];
            var lastAuthor = authors[authors.length - 1];

            if (authors.length > 2) {
                return React.createElement(
                    React.Fragment,
                    null,
                    _this.renderAuthor(firstAuthor),
                    ' .. ',
                    _this.renderAuthor(lastAuthor)
                );
            }

            return React.createElement(
                React.Fragment,
                null,
                _this.renderAuthor(firstAuthor),
                ', ',
                _this.renderAuthor(lastAuthor)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    InboxModuleAuthors.prototype.render = function render() {
        var _getAuthors = this.getAuthors(),
            unique = _getAuthors.unique,
            read = _getAuthors.read,
            unread = _getAuthors.unread;

        if (unique.length > 2) {
            return this.renderAuthors(unique);
        }

        if (unique.length === 2) {
            return this.renderAuthors(unique);
        }

        if (read.length && unread.length) {
            return React.createElement(
                React.Fragment,
                null,
                this.renderAuthor(read[0]),
                this.renderAuthors(unread)
            );
        }

        return React.createElement(ModuleAuthor, unique[0]);
    };

    return InboxModuleAuthors;
}(Component), _class.defaultProps = {
    messages: []
}, _temp2);


export default InboxModuleAuthors;